import { AccountUtilityHandler } from './account-utility-handler';
import { AddressUtilityHandler } from './address-utility-handler';
import { DatesUtilityHandler } from './dates-utility-handler';
import { FiltersUtilityHandler } from './filters-utility-handler';
import { InvoicesUtilityHandler } from './invoices-utility-handler';
import { JobsUtilityHandler } from './jobs-utility-handler';
import { MissionsUtilityHandler } from './missions-utility-handler';
import { PhoneUtilityHandler } from './phone-utility-handler';
import { PricesUtilityHandler } from './prices-utility-handler';
import { tva, TvaReturn } from './tva-utility-handler';
import { ValidatorUtilityHandler } from './validator-utility-handler';
import { MilesUtilityHandler } from './miles-utility-handler';

export class UtilityHandler {
    // Handlers
    private _missions: MissionsUtilityHandler;
    private _invoices: InvoicesUtilityHandler;
    private _account: AccountUtilityHandler;
    private _address: AddressUtilityHandler;
    private _phone: PhoneUtilityHandler;
    private _filters: FiltersUtilityHandler;
    private _dates: DatesUtilityHandler;
    private _prices: PricesUtilityHandler;
    private _jobs: JobsUtilityHandler;
    private _tva: TvaReturn;
    private _validator: ValidatorUtilityHandler;
    private _miles: MilesUtilityHandler;

    constructor(lang = 'fr') {
        this._missions = new MissionsUtilityHandler(lang);
        this._invoices = new InvoicesUtilityHandler(lang);
        this._phone = new PhoneUtilityHandler();
        this._account = new AccountUtilityHandler(lang);
        this._address = new AddressUtilityHandler();
        this._filters = new FiltersUtilityHandler(lang);
        this._dates = new DatesUtilityHandler(lang);
        this._prices = new PricesUtilityHandler();
        this._jobs = new JobsUtilityHandler();
        this._tva = tva();
        this._validator = new ValidatorUtilityHandler();
        this._miles = new MilesUtilityHandler();
    }

    //
    // ─── GETTERS ────────────────────────────────────────────────────────────────────
    //

    get missions(): MissionsUtilityHandler {
        return this._missions;
    }

    get invoices(): InvoicesUtilityHandler {
        return this._invoices;
    }

    get account(): AccountUtilityHandler {
        return this._account;
    }

    get address(): AddressUtilityHandler {
        return this._address;
    }

    get phone(): PhoneUtilityHandler {
        return this._phone;
    }

    get filters(): FiltersUtilityHandler {
        return this._filters;
    }

    get dates(): DatesUtilityHandler {
        return this._dates;
    }

    get prices(): PricesUtilityHandler {
        return this._prices;
    }

    get tva(): TvaReturn {
        return this._tva;
    }

    get jobs(): JobsUtilityHandler {
        return this._jobs;
    }

    get validator(): ValidatorUtilityHandler {
        return this._validator;
    }

    get miles(): MilesUtilityHandler {
        return this._miles;
    }
}
